import * as _ from 'lodash';
import { useState, useEffect } from 'react';
import { Actions, IRowData } from './models';
import { IListItem, IRecipient } from '@nkr/models/index';
import { DonorPreselectReviewStatus } from '@nkr/enums/index';
import { Button, FormControl, Label } from 'react-bootstrap';
import ConfirmBulkUpdate from './confirm-bulk-update';
import Grid from './grid';

interface IProps {
    list: IRowData[],
    pairedDonors: IRowData[],
    recipient: IRecipient,
    centerId: number,
    pendingMatchHistoryDonorId: number,
    hardBlockReasons: IListItem[],
    hardBlockReasonChoices: string[],
    donorPreselectReviewStatusList: IListItem[],
    groupIsSuper: boolean,
    section: number,
    subSection: number,
    isPreselectPage?: boolean,
    statusFilter?: number,
    onSortChange: (accessor: string, desc: boolean) => void,
    onAction: (recipientId: number, donorId: number, action: Actions) => void,
    onMultiHardblock: (isBulkUpdate: boolean) => void,
    onSelectAll: () => void,
    onSelected: (recipientId: number, donorId: number, checked: boolean) => void,
    onBulkUpdate: (bulkUpdateAction: string, isAccepted: boolean, isFullyConfident: boolean, hardBlockReason: number, reviewStatus: DonorPreselectReviewStatus) => void,
    onReviewStatusChange: (recipientId: number, donorId: number, reviewType: DonorPreselectReviewStatus) => void,
}

const PotentialDonorList = (props: IProps) => {
    const [bulkUpdateAction, setBulkUpdateAction] = useState('');
    const [hardBlockReason, setHardBlockReason] = useState(-1);
    const [reviewStatus, setReviewStatus] = useState(-1);
    const [showConfirmBulkUpdate, setShowConfirmBulkUpdate] = useState(false);
    const [statusFilter, setStatusFilter] = useState(props.statusFilter ?? 0);

    useEffect(() => {
        if (props.statusFilter !== undefined) {
            setStatusFilter(props.statusFilter);
        }
    }, [props.statusFilter]);

    const handleSetBulkUpdateAction = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let value = e.currentTarget.value;

        setBulkUpdateAction(e.currentTarget.value);

        if (value == 'decline') {
            setReviewStatus(1);
        }
    }

    const getDisableBulkUpdateButton = () => {
        let disableUpdateChecked = true;

        if (bulkUpdateAction == 'review' && props.list.filter(x => x.isSelected).length > 0 && reviewStatus != -1) {
            disableUpdateChecked = false;
        }

        if (bulkUpdateAction == 'decline' && props.list.filter(x => x.isSelected).length > 0 && reviewStatus != -1) {
            disableUpdateChecked = false;
        }

        return disableUpdateChecked;
    };

    const getBulkUpdateReason = () => {
        if (bulkUpdateAction == 'review') {
            let reason = props.donorPreselectReviewStatusList.find(x => x.id == reviewStatus);

            if (reason != null) {
                return reason.description;
            } else {
                return 'Remove Assigned Status';
            }
        }

        return '';
    };

    const handleConfirmBulkUpdate = () => {
        if (bulkUpdateAction == 'decline') {
            props.onMultiHardblock(true);
        } else {
            setShowConfirmBulkUpdate(true);
        }
    };

    const handleConfirmBulkUpdateYes = () => {
        let isAccepted: boolean = null;
        let isFullyConfident: boolean = null;

        if (bulkUpdateAction != 'review') {
            isAccepted = bulkUpdateAction == 'accepted' ? true : false;
            isFullyConfident = bulkUpdateAction == 'decline' ? null : bulkUpdateAction == 'accepted-fully-confident';
        }

        props.onBulkUpdate(bulkUpdateAction, isAccepted, isFullyConfident, hardBlockReason, reviewStatus);

        setShowConfirmBulkUpdate(false);
    };

    const handleConfirmBulkUpdateNo = () => {
        setShowConfirmBulkUpdate(false);
    };

    const disableUpdateChecked = getDisableBulkUpdateButton();
    const bulkUpdateReason = getBulkUpdateReason();

    const pendingCount = props.list.filter(x => x.donor.isAccepted == null && x.isPairedDonor == false).length;

    return (
        <>
            <Grid
                list={props.list}
                pairedDonors={props.pairedDonors}
                recipient={props.recipient}
                centerId={props.centerId}
                pendingMatchHistoryDonorId={props.pendingMatchHistoryDonorId}
                section={props.section}
                subSection={props.subSection}
                groupIsSuper={props.groupIsSuper}
                statusFilter={statusFilter}
                donorPreselectReviewStatusList={props.donorPreselectReviewStatusList}
                isPreselectPage={props.isPreselectPage}
                onAction={props.onAction}
                onSelectAll={props.onSelectAll}
                onSelected={props.onSelected}
                onReviewStatusChange={props.onReviewStatusChange} />

            <div style={{ paddingLeft: 0, paddingRight: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                {!props.isPreselectPage && (
                    <>
                        <div style={{ display: 'flex', width: '35%' }}>
                            <div style={{ marginRight: 5 }}>
                                <FormControl
                                    componentClass='select'
                                    value={bulkUpdateAction}
                                    onChange={handleSetBulkUpdateAction}
                                >
                                    <option value=''>- Select Bulk Update Option -</option>
                                    <option value='decline'>Decline - Not Acceptable</option>
                                    <option value='review'>Review</option>
                                </FormControl>
                            </div>

                            {bulkUpdateAction == 'review' && (
                                <div style={{ marginRight: 5 }}>
                                    <FormControl
                                        componentClass='select'
                                        value={reviewStatus}
                                        onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setReviewStatus(parseInt(e.currentTarget.value))}
                                    >
                                        <option value={-1}>- Select Review Status -</option>
                                        <option value={null}>- Remove Assigned Status -</option>
                                        {props.donorPreselectReviewStatusList.map(item =>
                                            <option key={'review-' + item.id} value={item.id}>{item.description}</option>
                                        )}
                                    </FormControl>
                                </div>
                            )}

                            <div><Button bsStyle='primary' disabled={disableUpdateChecked} onClick={handleConfirmBulkUpdate}>Update Checked</Button></div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', width: '35%' }}>
                            <div style={{ marginRight: 5 }}>Filter&nbsp;by&nbsp;Review&nbsp;Status:</div>
                            <FormControl
                                componentClass='select'
                                style={{ width: 'initial' }}
                                value={statusFilter}
                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setStatusFilter(parseInt(e.currentTarget.value))}
                            >
                                <option value={-1}>- All -</option>
                                {props.donorPreselectReviewStatusList.map(item =>
                                    <option key={'review-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </div>
                    </>
                )}

                {!props.isPreselectPage && (
                    <>
                        <div>
                            <Label style={{ fontSize: '100%' }}>{pendingCount} pending/re-eval</Label>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <Label style={{ fontSize: '100%', backgroundColor: 'darkgreen' }}>Paired donor of the recipient</Label>
                        </div>
                    </>
                )}
            </div>

            <ConfirmBulkUpdate
                show={showConfirmBulkUpdate}
                action={bulkUpdateAction}
                reason={bulkUpdateReason}
                list={props.list.filter(x => x.isSelected).map(x => x)}
                onYes={handleConfirmBulkUpdateYes}
                onNo={handleConfirmBulkUpdateNo}
            />
        </>
    );
}

export default PotentialDonorList;